// import React from 'react'
// import './Banners.css'

// function Banners(props) {
//     const { banners, names } = props
//     return <div className="Banners_root">
//         <button className={props.selected === '' ? "Banners_selectedimg" : "Banners_img"} key={'emptybanner'} onClick={() => { props.select({ img: '', index: 0 }) }}>
//             <div className='Banners_name' style={{ placeContent: 'center', height: '100%', color: '' === props.selected ? 'var(--mainpink)' : 'inherit' }}>Blank</div>
//         </button>
//         {banners.map((banner, i) => {
//             const cn = props.selected === banner ? "Banners_selectedimg" : "Banners_img"
//             const onclick = () => { props.select({ img: banner, index: i }) }
//             const name = names[i]
//             return i > 0
//                 ? <button className={cn} key={banner + i} onClick={onclick}>
//                     <div className='Banners_semiroot' style={{ padding: banner === props.selected ? 0 : 2 }}>
//                         <div className='Banners_name' style={{ color: banner === props.selected ? 'var(--mainpink)' : 'inherit' }}> {name}</div>
//                         <img style={{ width: 'auto', height: 30, margin: 5 }} src={banner} alt="" />
//                     </div>
//                 </button>
//                 : null
//         })}
//     </div>
// }
// export default Banners

import React from 'react'
import './Banners.css'

function Banners(props) {
    const { banners, names } = props
    const emptycheck = props.selected === ''
    return <div className="Banners_root">

        <span
            key={'emptybanner'}
            className={emptycheck ? "Banners_selectedimg" : "Banners_img"}
            onClick={() => { props.select({ img: '', index: 0 }) }}
        >
            <div className={`${emptycheck ? 'Banners_selectedname' : 'Banners_name'}`}>Empty</div>
            <div className={`${emptycheck ? 'Banners_selectedbanner' : 'Banners_banner'}`} />
            {emptycheck ? <div className='Banners_selectedtext'>Selected</div> : null}
        </span>

        {banners.map((banner, i) => {
            const check = props.selected === banner
            const onclick = () => { props.select({ img: banner, index: i }) }
            const name = names[i]
            return i > 0
                ? <span
                    key={banner + i}
                    className={check ? "Banners_selectedimg" : "Banners_img"}
                    onClick={onclick}
                >
                    <div className={`${check ? 'Banners_selectedname' : 'Banners_name'}`}> {name}</div>
                    <img className={`${check ? 'Banners_selectedbanner' : 'Banners_banner'}`} src={banner} alt="" />
                    {check ? <div className='Banners_selectedtext'>Selected</div> : null}
                </span>
                : null
        })}
    </div>
}
export default Banners